var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#20D5FF",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_3039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2288 16.2144C45.0775 20.2 48.2126 29.7928 44.227 37.6414C40.2414 45.4973 30.6486 48.6252 22.8 44.6396C14.9513 40.654 11.8162 31.0612 15.8018 23.2126C19.7874 15.3639 29.3802 12.2288 37.2288 16.2144Z",
    fill: "#00CFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4541 25.3464L31.5857 27.1626C31.9172 27.6959 32.3929 28.1284 32.955 28.4167L33.0055 28.4383C33.4811 28.6833 33.6757 29.2599 33.4307 29.7428C33.0127 30.5716 31.9965 30.9031 31.1676 30.4851C30.382 30.0887 29.4739 30.0167 28.6379 30.2905L28.0902 30.4707C27.0379 30.8167 25.892 30.723 24.9046 30.2257L22.5622 29.0365C21.8199 28.6617 20.919 28.9572 20.537 29.6995L20.3929 29.9806C19.8307 31.0833 18.4829 31.5302 17.373 30.968L16.155 30.3482C14.9947 29.7572 14.2019 28.4311 14.3892 27.3067C14.728 25.6491 15.2901 24.2581 15.773 23.3067C16.4217 22.0311 17.2865 20.8563 18.2883 19.6527C19.0163 18.7806 20.6811 19.7896 21.7622 19.4365C22.6992 19.1266 23.7298 19.2058 24.6091 19.6527L25.5244 20.114C26.0217 20.3662 26.6271 20.1716 26.8793 19.6743C27.0739 19.2851 27.6433 19.3284 27.7802 19.7392L28.2199 21.0797C28.5442 22.0671 28.9911 23.0112 29.546 23.8977L30.4541 25.3464Z",
    fill: "#19BF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2271 26.4266C37.1785 26.9095 38.2884 26.996 39.3046 26.6645L41.0055 26.1095C42.2884 25.6915 43.6866 25.7996 44.8902 26.4122L45.4884 26.7149C44.4073 22.3978 41.5244 18.5492 37.2433 16.3726C36.537 16.0122 35.8235 15.7167 35.0956 15.4717L34.8505 15.551L33.7478 17.7347C33.3658 18.4843 33.301 19.3564 33.5604 20.1564L33.8127 20.9347C33.9785 21.432 33.9352 21.9726 33.6974 22.4411C33.4523 22.9311 33.4091 23.4933 33.5749 24.0122L33.5821 24.0266C33.8415 24.8338 34.4181 25.4969 35.1749 25.8861L36.2271 26.4266Z",
    fill: "#19BF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6955 37.7492C27.6864 38.1024 26.8504 38.8375 26.3819 39.7961L25.6036 41.4105C25.0126 42.6213 23.9675 43.5582 22.6919 43.9979L22.0576 44.2213C25.9207 46.4411 30.6846 47.0393 35.2252 45.4681C35.9675 45.2087 36.681 44.8988 37.3657 44.5456L37.481 44.3078L36.681 41.9943C36.4072 41.2015 35.8234 40.5456 35.0666 40.1781L34.3243 39.8177C33.8558 39.5871 33.4955 39.1835 33.3225 38.6862C33.1423 38.1672 32.7675 37.742 32.2774 37.5042L32.263 37.497C31.4991 37.1294 30.6198 37.0717 29.8198 37.3528L28.6955 37.7492Z",
    fill: "#19BF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4541 25.3464L31.5857 27.1626C31.9172 27.6959 32.3929 28.1284 32.955 28.4167L33.0055 28.4383C33.4811 28.6833 33.6757 29.2599 33.4307 29.7428C33.0127 30.5716 31.9965 30.9031 31.1676 30.4851C30.382 30.0887 29.4739 30.0167 28.6379 30.2905L28.0902 30.4707C27.0379 30.8167 25.892 30.723 24.9046 30.2257L22.5622 29.0365C21.8199 28.6617 20.919 28.9572 20.537 29.6995L20.3929 29.9806C19.8307 31.0833 18.4829 31.5302 17.373 30.968L16.155 30.3482C14.9947 29.7572 14.2019 28.4311 14.3892 27.3067C14.728 25.6491 15.2901 24.2581 15.773 23.3067C16.4217 22.0311 17.2865 20.8563 18.2883 19.6527C19.0163 18.7806 20.6811 19.7896 21.7622 19.4365C22.6992 19.1266 23.7298 19.2058 24.6091 19.6527L25.5244 20.114C26.0217 20.3662 26.6271 20.1716 26.8793 19.6743C27.0739 19.2851 27.6433 19.3284 27.7802 19.7392L28.2199 21.0797C28.5442 22.0671 28.9911 23.0112 29.546 23.8977L30.4541 25.3464Z",
    fill: "url(#paint0_linear_562_3039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2271 26.4266C37.1785 26.9095 38.2884 26.996 39.3046 26.6645L41.0055 26.1095C42.2884 25.6915 43.6866 25.7996 44.8902 26.4122L45.4884 26.7149C44.4073 22.3978 41.5244 18.5492 37.2433 16.3726C36.537 16.0122 35.8235 15.7167 35.0956 15.4717L34.8505 15.551L33.7478 17.7347C33.3658 18.4843 33.301 19.3564 33.5604 20.1564L33.8127 20.9347C33.9785 21.432 33.9352 21.9726 33.6974 22.4411C33.4523 22.9311 33.4091 23.4933 33.5749 24.0122L33.5821 24.0266C33.8415 24.8338 34.4181 25.4969 35.1749 25.8861L36.2271 26.4266Z",
    fill: "url(#paint1_linear_562_3039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6955 37.7492C27.6864 38.1024 26.8504 38.8375 26.3819 39.7961L25.6036 41.4105C25.0126 42.6213 23.9675 43.5582 22.6919 43.9979L22.0576 44.2213C25.9207 46.4411 30.6846 47.0393 35.2252 45.4681C35.9675 45.2087 36.681 44.8988 37.3657 44.5456L37.481 44.3078L36.681 41.9943C36.4072 41.2015 35.8234 40.5456 35.0666 40.1781L34.3243 39.8177C33.8558 39.5871 33.4955 39.1835 33.3225 38.6862C33.1423 38.1672 32.7675 37.742 32.2774 37.5042L32.263 37.497C31.4991 37.1294 30.6198 37.0717 29.8198 37.3528L28.6955 37.7492Z",
    fill: "url(#paint2_linear_562_3039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2288 16.2144C45.0775 20.2 48.2126 29.7928 44.227 37.6414C40.2414 45.4973 30.6486 48.6252 22.8 44.6396C14.9513 40.654 11.8162 31.0612 15.8018 23.2126C19.7874 15.3639 29.3802 12.2288 37.2288 16.2144Z",
    fill: "url(#paint3_linear_562_3039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4541 25.3464L31.5857 27.1626C31.9172 27.6959 32.3929 28.1284 32.955 28.4167L33.0055 28.4383C33.4811 28.6833 33.6757 29.2599 33.4307 29.7428C33.0127 30.5716 31.9965 30.9031 31.1676 30.4851C30.382 30.0887 29.4739 30.0167 28.6379 30.2905L28.0902 30.4707C27.0379 30.8167 25.892 30.723 24.9046 30.2257L22.5622 29.0365C21.8199 28.6617 20.919 28.9572 20.537 29.6995L20.3929 29.9806C19.8307 31.0833 18.4829 31.5302 17.373 30.968L16.155 30.3482C14.9947 29.7572 14.2019 28.4311 14.3892 27.3067C14.728 25.6491 15.2901 24.2581 15.773 23.3067C16.4217 22.0311 17.2865 20.8563 18.2883 19.6527C19.0163 18.7806 20.6811 19.7896 21.7622 19.4365C22.6992 19.1266 23.7298 19.2058 24.6091 19.6527L25.5244 20.114C26.0217 20.3662 26.6271 20.1716 26.8793 19.6743C27.0739 19.2851 27.6433 19.3284 27.7802 19.7392L28.2199 21.0797C28.5442 22.0671 28.9911 23.0112 29.546 23.8977L30.4541 25.3464Z",
    fill: "#19BF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2271 26.4266C37.1785 26.9095 38.2884 26.996 39.3046 26.6645L41.0055 26.1095C42.2884 25.6915 43.6866 25.7996 44.8902 26.4122L45.4884 26.7149C44.4073 22.3978 41.5244 18.5492 37.2433 16.3726C36.537 16.0122 35.8235 15.7167 35.0956 15.4717L34.8505 15.551L33.7478 17.7347C33.3658 18.4843 33.301 19.3564 33.5604 20.1564L33.8127 20.9347C33.9785 21.432 33.9352 21.9726 33.6974 22.4411C33.4523 22.9311 33.4091 23.4933 33.5749 24.0122L33.5821 24.0266C33.8415 24.8338 34.4181 25.4969 35.1749 25.8861L36.2271 26.4266Z",
    fill: "#19BF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6955 37.7492C27.6864 38.1024 26.8504 38.8375 26.3819 39.7961L25.6036 41.4105C25.0126 42.6213 23.9675 43.5582 22.6919 43.9979L22.0576 44.2213C25.9207 46.4411 30.6846 47.0393 35.2252 45.4681C35.9675 45.2087 36.681 44.8988 37.3657 44.5456L37.481 44.3078L36.681 41.9943C36.4072 41.2015 35.8234 40.5456 35.0666 40.1781L34.3243 39.8177C33.8558 39.5871 33.4955 39.1835 33.3225 38.6862C33.1423 38.1672 32.7675 37.742 32.2774 37.5042L32.263 37.497C31.4991 37.1294 30.6198 37.0717 29.8198 37.3528L28.6955 37.7492Z",
    fill: "#19BF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4541 25.3464L31.5857 27.1626C31.9172 27.6959 32.3929 28.1284 32.955 28.4167L33.0055 28.4383C33.4811 28.6833 33.6757 29.2599 33.4307 29.7428C33.0127 30.5716 31.9965 30.9031 31.1676 30.4851C30.382 30.0887 29.4739 30.0167 28.6379 30.2905L28.0902 30.4707C27.0379 30.8167 25.892 30.723 24.9046 30.2257L22.5622 29.0365C21.8199 28.6617 20.919 28.9572 20.537 29.6995L20.3929 29.9806C19.8307 31.0833 18.4829 31.5302 17.373 30.968L16.155 30.3482C14.9947 29.7572 14.2019 28.4311 14.3892 27.3067C14.728 25.6491 15.2901 24.2581 15.773 23.3067C16.4217 22.0311 17.2865 20.8563 18.2883 19.6527C19.0163 18.7806 20.6811 19.7896 21.7622 19.4365C22.6992 19.1266 23.7298 19.2058 24.6091 19.6527L25.5244 20.114C26.0217 20.3662 26.6271 20.1716 26.8793 19.6743C27.0739 19.2851 27.6433 19.3284 27.7802 19.7392L28.2199 21.0797C28.5442 22.0671 28.9911 23.0112 29.546 23.8977L30.4541 25.3464Z",
    fill: "url(#paint4_linear_562_3039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2271 26.4266C37.1785 26.9095 38.2884 26.996 39.3046 26.6645L41.0055 26.1095C42.2884 25.6915 43.6866 25.7996 44.8902 26.4122L45.4884 26.7149C44.4073 22.3978 41.5244 18.5492 37.2433 16.3726C36.537 16.0122 35.8235 15.7167 35.0956 15.4717L34.8505 15.551L33.7478 17.7347C33.3658 18.4843 33.301 19.3564 33.5604 20.1564L33.8127 20.9347C33.9785 21.432 33.9352 21.9726 33.6974 22.4411C33.4523 22.9311 33.4091 23.4933 33.5749 24.0122L33.5821 24.0266C33.8415 24.8338 34.4181 25.4969 35.1749 25.8861L36.2271 26.4266Z",
    fill: "url(#paint5_linear_562_3039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6955 37.7492C27.6864 38.1024 26.8504 38.8375 26.3819 39.7961L25.6036 41.4105C25.0126 42.6213 23.9675 43.5582 22.6919 43.9979L22.0576 44.2213C25.9207 46.4411 30.6846 47.0393 35.2252 45.4681C35.9675 45.2087 36.681 44.8988 37.3657 44.5456L37.481 44.3078L36.681 41.9943C36.4072 41.2015 35.8234 40.5456 35.0666 40.1781L34.3243 39.8177C33.8558 39.5871 33.4955 39.1835 33.3225 38.6862C33.1423 38.1672 32.7675 37.742 32.2774 37.5042L32.263 37.497C31.4991 37.1294 30.6198 37.0717 29.8198 37.3528L28.6955 37.7492Z",
    fill: "url(#paint6_linear_562_3039)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_562_3039",
    x1: 18.0966,
    y1: 32.5011,
    x2: 29.3585,
    y2: 21.2391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1352,
    stopColor: "#D6D6D9",
    stopOpacity: 0.041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3657,
    stopColor: "#96979D",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5757,
    stopColor: "#64646E",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#3F404C",
    stopOpacity: 0.227
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9057,
    stopColor: "#292A38",
    stopOpacity: 0.272
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212230",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_562_3039",
    x1: 35.1827,
    y1: 26.1241,
    x2: 41.6505,
    y2: 19.6563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1352,
    stopColor: "#D6D6D9",
    stopOpacity: 0.041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3657,
    stopColor: "#96979D",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5757,
    stopColor: "#64646E",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#3F404C",
    stopOpacity: 0.227
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9057,
    stopColor: "#292A38",
    stopOpacity: 0.272
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212230",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_562_3039",
    x1: 25.8633,
    y1: 48.0273,
    x2: 34.5065,
    y2: 39.3841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1352,
    stopColor: "#D6D6D9",
    stopOpacity: 0.041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3657,
    stopColor: "#96979D",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5757,
    stopColor: "#64646E",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#3F404C",
    stopOpacity: 0.227
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9057,
    stopColor: "#292A38",
    stopOpacity: 0.272
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212230",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_562_3039",
    x1: 14.0721,
    y1: 30.43,
    x2: 45.959,
    y2: 30.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1912,
    stopColor: "#1BD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5996,
    stopColor: "#61E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAF1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_562_3039",
    x1: 14.3575,
    y1: 25.2147,
    x2: 33.5287,
    y2: 25.2147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B54A",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_562_3039",
    x1: 33.4021,
    y1: 21.1679,
    x2: 45.4941,
    y2: 21.1679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B54A",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_562_3039",
    x1: 22.054,
    y1: 41.7678,
    x2: 37.4735,
    y2: 41.7678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B54A",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_3039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 33.4414,
    fill: "white",
    transform: "translate(14 13)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.dc4ff0c09d930d1699d0879c5d7dc0bb.svg";
export { ForwardRef as ReactComponent };